// frontend/modules/document-type/hooks/useDocumentTypes.ts
import { useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { 
  useGetAllDocumentTypes,
  useGetDocumentType,
  useCreateDocumentType,
  useUpdateDocumentType,
  useDeleteDocumentType
} from '@/shared/api/client/document-type-controller';
import { useDocumentTypeStore } from '../stores/document-type-store';
// import { DocumentTypeFormData, CreateDocumentTypeRequest, UpdateDocumentTypeRequest } from '../types/document-type.types';

export const useDocumentTypes = () => {
    const queryClient = useQueryClient();
    const { setError } = useDocumentTypeStore();

    // Create document type mutation using orval-generated hook
    const createMutation = useCreateDocumentType({
        mutation: {
            onSuccess: () => {
                message.success('Document type created successfully');
                queryClient.invalidateQueries({ queryKey: ['document-types'] });
            },
            onError: (error: any) => {
                const errorMessage = error?.response?.data?.message || error?.message || 'Failed to create document type';
                message.error(errorMessage);
                setError(errorMessage);
            }
        }
    });

    // Update document type mutation using orval-generated hook
    const updateMutation = useUpdateDocumentType({
        mutation: {
            onSuccess: () => {
                message.success('Document type updated successfully');
                queryClient.invalidateQueries({ queryKey: ['document-types'] });
            },
            onError: (error: any) => {
                const errorMessage = error?.response?.data?.message || error?.message || 'Failed to update document type';
                message.error(errorMessage);
                setError(errorMessage);
            }
        }
    });

    // Delete document type mutation using orval-generated hook
    const deleteMutation = useDeleteDocumentType({
        mutation: {
            onSuccess: () => {
                message.success('Document type deleted successfully');
                queryClient.invalidateQueries({ queryKey: ['document-types'] });
            },
            onError: (error: any) => {
                const errorMessage = error?.response?.data?.message || error?.message || 'Failed to delete document type';
                message.error(errorMessage);
                setError(errorMessage);
            }
        }
    });

    return {
        // Query hooks - orval-generated
        useGetAllDocumentTypes,
        useGetDocumentType,
        
        // Mutation hooks
        createDocumentType: createMutation,
        updateDocumentType: updateMutation,
        deleteDocumentType: deleteMutation,
        
        // Loading states
        isCreating: createMutation.isPending,
        isUpdating: updateMutation.isPending,
        isDeleting: deleteMutation.isPending
    };
};
